import PerfectScrollbar from "perfect-scrollbar";

export default {
  methods: {
    initPerfectScrollbar(container, options) {
      this.$nextTick(() => {
        this.ps = new PerfectScrollbar(container, options);
      })
    }
  }
}
